import { useDeletePhoneCenter } from "./api/deletePhoneCenter";
import { Button } from "reactstrap";


const DeletePhoneCenter = ({handleCloseModal, PhoneCenterId}: DeletePhoneCenterProps)  => {
  
  const deletePhoneCenterMutation = useDeletePhoneCenter({ PhoneCenterId});
  const handleSubmit = async (): Promise<void> => {
    deletePhoneCenterMutation.mutateAsync({ 
      PhoneCenterId: PhoneCenterId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε τον Τηλεφωνικό Κέντρο;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeletePhoneCenterProps{
  PhoneCenterId: number;
  handleCloseModal: () => void;
}

export default DeletePhoneCenter;